export const LoadingComponent = () => {
  return <span>Authentication in progress...</span>;
};
